<template>
    <div>
        <label v-show="hasLabel" :for="id" class="block text-sm font-medium text-gray-700">{{ label }}<span v-show="$attrs.required || false" class="text-teal font-bold">*</span></label>
        <div :class="{
            'mt-1': hasLabel
        }">
            <textarea @input="handleInput($event)" :id="id" :value="modelValue" rows="5" v-bind="normalizeInputAttributes" class="flex-1 focus:ring-teal focus:border-teal block w-full sm:text-sm border-gray-300 rounded-md"></textarea>
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default(){
                return 'input-field-' + Math.random().toString(36).substr(2, 9);
            }
        },
        modelValue: null
    },
    emits: ['update:modelValue'],
    setup(_, { emit }){
        function handleInput(e){
            emit('update:modelValue', e.target.value);
        }

        return {
            handleInput
        }
    },
    computed: {
        hasLabel(){
            return this.label != '';
        }
    }
}
</script>

<style>

</style>
